import { Link } from "react-router-dom";
import logo from "./../../images/logo.svg";
import style from "./pageNotFound.module.css";

const PageNotFound = () => {
  return (
    <section className={style.wrapper}>
      <div className={style.wrapper_header}>
        <h2>Страница на сайте не существует</h2>
        <img src={logo} alt="Логотип примпиво" />
      </div>
      <p>Возможно, вы ошиблись в URL адресе</p>
      <Link to="/">Перейти на главную страницу</Link>
    </section>
  );
};

export default PageNotFound;
